export function DocumentTextOutline({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6666 1.66666L18.3333 8.33332V12.5C18.3333 16.6667 16.6666 18.3333 12.5 18.3333H7.49996C3.33329 18.3333 1.66663 16.6667 1.66663 12.5V7.49999C1.66663 3.33332 3.33329 1.66666 7.49996 1.66666H11.6666ZM18.3333 8.33332H15C12.5 8.33332 11.6666 7.49999 11.6666 4.99999V1.66666M5.83329 10.8333H10.8333M5.83329 14.1667H9.16663"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
